declare const process: {
    env: {
        REACT_APP_REGION?: string;
        [key: string]: string | undefined;
    };
};

export interface RouteItem {
    path: string;
    element: any;
    permissionCode?: string;
    regions?: string[];
}

/**
 * 权限检查高阶组件
 * @param element - 要渲染的组件
 * @param permissions - 用户拥有的权限列表
 * @param NoPermission - 无权限时显示的组件
 * @param permissionCode - 可选的权限代码
 * @param regions - 可选的地区数组
 * @returns 如果没有权限或地区访问权限，则返回无权限组件，否则返回原组件
 */
function withPermissionCheck(
    element: any,
    permissions: Record<string, boolean>,
    NoPermission: HTMLElement,
    permissionCode?: string,
    regions?: string[]
) {
    const region = process.env.REACT_APP_REGION;
    const hasRegionAccess = !region || regions?.includes(region); // 检查地区访问权限
    const hasPermission = !permissionCode || permissions[permissionCode]; // 检查权限

    // 任何地区不符合或者没有权限的时候返回403页面
    if (!hasRegionAccess || !hasPermission) {
        return NoPermission;
    }
    return element; // 返回原组件
}

/**
* 微应用权限路由
*/
export function authGuard(authGuardParams: any): RouteItem[] {
    const { permissions, permissonRouters, commonRouters, NoPermission } = authGuardParams;
    // 处理权限路由
    const permissionFilteredRoutes = permissonRouters.map((route: RouteItem) => ({
        ...route,
        element: withPermissionCheck(
            route.element,
            permissions,
            NoPermission,
            route.permissionCode,
            route.regions
        ),
    }));

    return [...permissionFilteredRoutes, ...commonRouters];
}
